/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */

import React from 'react';
import ApiExplorer from './ApiExplorer';

// Light weight veneer version, add more dependencies and featues here.
function ApiExplorerApp({ options, apis, encodedApis, apps, docs }) {
    return <ApiExplorer options={options} apis={apis} encodedApis={encodedApis} apps={apps} docs={docs} />;
}

export default ApiExplorerApp;